<template>
  <div 
    :class="['stats-chart', css]"
  >
    <div 
      v-if="title"
      class="chart-header"
    >
      <h3 class="chart-title">{{ title }}</h3>
      <div class="chart-legend"></div>
    </div>
    <div class="chart-content">
      <div 
        :class="['column-chart', {'bar-count': includeCounts}]"
        :style="[{'height': graphHeight}]"
      >
        <div 
          v-for="(stat, index) in stats"
          :key="index"
          class="bar" 
          :style="[{'--count': stat.count}, {'--bar-height': stat.height}, {'min-height': this.barsMinHeight}, {'--bar-color': stat.color}]"
          :ref="'bar-' + index"
        >
          <span v-if="includeCounts">{{ stat.count }}</span>
        </div>
        <div
          v-if="includeTotal"
          class="chart-total"
        >{{ total }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },

  props: {
    title: String,
    data: Array,
    css: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100%'
    },
    barsHeight: String,
    barsMinHeight: String,
    includeCounts: Boolean,
    includeTotal: Boolean,
    showTooltips: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      stats: [],
      total: null
    }
  },

  watch: {
    data: {
      handler(newValue, oldValue) {
        this.setData()
      }, 
      immediate: true
    }
  },

  mounted: function() {
    if (this.showTooltips) {
      const vm = this;
      
      this.stats.forEach((stat, index) => {
        const bar = this.$refs['bar-' + index];

        const t = new bootstrap.Tooltip(bar[0], {
          title: stat.title,
          html: true,
          placement: 'top',
          trigger : 'hover'
        })
      })
    }
  },

  computed: {
    graphHeight: function() {
      return this.barsHeight ? '' : this.height;
    }
  },

  methods: {
    setData: function() {
      this.total = this.data.length > 0 ? this.data[0][4] : null;

      this.stats = this.data.map((s) => {
        const p = Math.round(s[3] * 10) / 10;

        return {
          color: s[4],
          count: s[1],
          title: s[2],
          percentage: p,
          height: this.barsHeight || p + '%'
        }
      })
    }
  }
}

</script>